import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { throwError } from 'rxjs';
import {environment} from 'src/environments/environment';
import { map, catchError } from 'rxjs/operators';
import { EnvironmentConfiguration } from '../environment/services/environment.configuration';

var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
var httpOptions;
if (isIEOrEdge) {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
      'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
    })
  };
} else {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': localStorage.getItem('Ebom_accessToken')
    })
  };
}

@Injectable({
  providedIn: 'root'
})
export class ProductWithinVersionEditDialogService {
  editprodwithinVer = '/editProdWithinVersion/{proxy+}'
  constructor(private http: HttpClient, private environment: EnvironmentConfiguration) { }
  editprodwithinVersions(body): Observable<any> {
    var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    const url= this.environment.BusinessActionRestapiUrl + this.editprodwithinVer
    return this.http.post(url,body, httpOptions)
      .pipe(map((res: any) => res), catchError(this.handleError))
  }
  
 // ===================================== Exception Handler ===========================================
 private handleError(error: HttpErrorResponse) {
  var errorMsg = '';
  if (error.error instanceof ErrorEvent) {
    //A client-side or network error occurred. Handle it accordingly.
    errorMsg = `An error occurred: ${error.error.message}`;
  } else {
    //The backend returned an unsuccessful response code.
    //The response body may contain clues as to what went wrong,
    errorMsg = `Backend returned code ${error}`;
  }
  //return an observable with a user-facing error message
  return throwError(errorMsg);
}
}
